import { getDateDiffFromNow } from '../../../utils/dates';

const ONE_MINUTE = 1;
const FULL_HOUR_IN_MINUTES = 60;
const FULL_DAY_IN_HOURS = 24;

export const getLastSyncTooltipText = (lastSync: Date | null | undefined): string => {
    if (!lastSync) return 'Last sync time unavailable';

    const diffMinutes = getDateDiffFromNow(lastSync, 'minutes');
    const diffHours = getDateDiffFromNow(lastSync, 'hours');
    const diffDays = getDateDiffFromNow(lastSync, 'days');

    if (diffMinutes < ONE_MINUTE) return 'Last successful sync a minute ago';
    if (diffMinutes < FULL_HOUR_IN_MINUTES) return `Last successful sync ${diffMinutes} minutes ago`;
    if (diffHours < FULL_DAY_IN_HOURS) return `Last successful sync ${diffHours} hours ago`;
    return `Last successful sync ${diffDays} days ago`;
};
